import styled from 'styled-components';

const StyledCheckBoxArea = styled.div`
  width: ${props => props?.styles?.width || '100%'};
  min-width: ${props => props?.styles?.width || '100%'};
  height: ${props => props?.styles?.height || '100%'};
  min-height: ${props => props?.styles?.height || '100%'};

  padding-top: ${props => props?.styles?.paddingTop || '12px'};
  padding-bottom: ${props => props?.styles?.paddingBottom || '12px'};
  padding-left: ${props => props?.styles?.paddingLeft || '12px'};
  padding-right: ${props => props?.styles?.paddingRight || '12px'};

  border-radius: 5px;
  border: 1px solid #d9d9d9;
`;

export default StyledCheckBoxArea;
